/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import NextOrSkipButtons from "../../shared/ui/components/NextOrSkipButtons";
import { useForm } from "react-hook-form";
import useStyles from "./style";
import SelectedTemplates from "../../shared/ui/components/SelectedTemplates";
import Spinner from "../../shared/ui/components/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountries,
  getMobileCodes,
  selectCountries,
  selectMobileCodes,
} from "../../store/slicers/template";
import {
  recipientCountry,
  selectFormData,
  setFormData,
} from "../../store/slicers/address";
import AddressForm from "./components/form";
import { CountryWithMobileCode, RecipientCountry } from "./models/address";
import { getPreOrder, updatePreOrder } from "../../store/slicers/preorder";
import Cookies from "js-cookie";
import { hasUniqueID } from "../../shared/helpers/preOrder";
import { ECountries } from "../../resources/constants";
import { Box } from "@mui/material";

const Address = (): JSX.Element => {
  const countries = useSelector(selectCountries);
  const mobileCodes = useSelector(selectMobileCodes);
  const formDataValues = useSelector(selectFormData);
  const [loaded, setLoaded] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState,
    setError,
    reset,
    clearErrors,
  } = useForm({
    mode: "all",
    defaultValues: {
      ...formDataValues,
    },
  });
  const values = watch();
  const styles = useStyles();

  useEffect(() => {
    if (!countries.length && !mobileCodes.length) {
      Promise.all([
        dispatch(getCountries()).then((res: any) => {
          if (res?.payload?.length > 0) {
            //edited
            const armenianCountry = res.payload.find(
              (item: RecipientCountry) => item.id === ECountries.Armenia
            );
            setValue(
              "recipientCountry",
              formDataValues?.recipientCountry
                ? formDataValues?.recipientCountry
                : armenianCountry
            );
            dispatch(
              recipientCountry(
                formDataValues?.recipientCountry
                  ? formDataValues?.recipientCountry
                  : armenianCountry
              )
            );
          }
        }),
        dispatch(getMobileCodes()).then((res: any) => {
          if (res?.payload?.length > 0) {
            setValue(
              "countryWithCodes",
              formDataValues?.countryWithCodes
                ? formDataValues?.countryWithCodes
                : res.payload.find(
                    (item: CountryWithMobileCode) => item.id === 306
                  )
            );
          }
        }),
      ]).finally(() => {
        setLoaded(true);
      });
    } else {
      if (
        !formDataValues?.countryWithCodes &&
        !formDataValues?.recipientCountry
      ) {
        //edited
        const armenianCountry = countries.find(
          (item: RecipientCountry) => item.id === ECountries.Armenia
        );
        setValue(
          "countryWithCodes",
          mobileCodes.find((item: CountryWithMobileCode) => item.id === 306)
        );
        //edited
        setValue(
          "recipientCountry",
          countries.find(
            (item: RecipientCountry) => item.id === ECountries.Armenia
          )
        );
        dispatch(
          recipientCountry(
            formDataValues?.recipientCountry
              ? formDataValues?.recipientCountry
              : armenianCountry
          )
        );
      }
      setLoaded(true);
    }
  }, [countries.length, dispatch, mobileCodes.length, setValue]);

  const submitBtnDisabledStatus = () => {
    return values.firstName &&
      values.email &&
      values.phoneNumber &&
      (values.region || values.customRegion) &&
      (values.district || values.customDistrict) &&
      (values.street || values.customStreet) &&
      values.countryWithCodes &&
      values.recipientCountry &&
      ((values.building && values.apartment) || values.house) &&
      !Object.keys(formState.errors).length
      ? false
      : true;
  };

  const onSubmit = async (data: any) => {
    const preorderData = {
      key: Cookies.get("uniqueId"),
      route: "/price",
      json: JSON.stringify(data).replace(/"/g, "¶œÆ"),
    };
    if (hasUniqueID()) {
      await dispatch(updatePreOrder(preorderData));
    }
    dispatch(getPreOrder(Cookies.get("uniqueId")));
    dispatch(setFormData(data));
  };

  return (
    <>
      <div className={styles.root}>
        {loaded && countries?.length > 0 && mobileCodes?.length > 0 ? (
          <>
            <Box pb={5}>
              <NextOrSkipButtons
                nextButtonText="Շարունակել"
                nextPagePath="price"
                disabled={submitBtnDisabledStatus()}
                nextOrSkipBtnAction={handleSubmit(onSubmit)}
              />
            </Box>
            <div className={styles.row}>
              <div className={styles.leftPane}>
                <SelectedTemplates />
              </div>
              <div className={styles.rightPane}>
                <form>
                  <AddressForm
                    control={control}
                    watch={watch}
                    styles={styles}
                    setValue={setValue}
                    formState={formState}
                    clearErrors={clearErrors}
                    setError={setError}
                    reset={reset}
                  />
                  <NextOrSkipButtons
                    nextButtonText="Շարունակել"
                    nextPagePath="price"
                    disabled={submitBtnDisabledStatus()}
                    nextOrSkipBtnAction={handleSubmit(onSubmit)}
                  />
                </form>
              </div>
            </div>
          </>
        ) : (
          <div className={styles.spinnerWrapper}>
            <Spinner size={50} />
          </div>
        )}
      </div>
    </>
  );
};

export default Address;
